import React from 'react';

import useUserHook from 'hooks/useUserHook';

import { QuickLinkCard } from 'components/Mobile/components/quickLinkCard';
import classes from 'components/Mobile/pages/home/components/QuickLinks/quickLinks.module.scss';
import { useHomeQuickLinks } from 'components/Mobile/pages/home/hooks/useHomeQuickLinks';

interface QuickLink {
    name: string;
    gotoFunc?: () => void;
    filter?: {};
}

export const QuickLinks = () => {
    const { goToQuickLink } = useHomeQuickLinks();
    const { username, firstName, lastName } = useUserHook();

    const goToProgramBoardView = () => {
        goToQuickLink({});
    };

    const goToProgramUpdatedByMe = () => {
        goToQuickLink({
            updatedBy: {
                id: null,
                value: username,
                label: `${firstName} ${lastName}}`,
                assignee: {
                    id: null,
                    userName: username,

                    firstName: firstName,
                    lastName: lastName,
                    imageName: '',
                },
            },
        });
    };

    const goto30dLookAhead = () => {
        goToQuickLink({
            finishDate: {
                value: [],
                type: 'TODAY_REF',
            },
            flags: {
                endDatesRange: 'TODAY_REF_NEXT_30_DAYS',
            },
        });
    };

    const gotoMyTrackedActivities = () => {
        goToQuickLink({
            trackedActivity: { label: 'Yes', value: '1' },
        });
    };

    const gotoMyPriorities = () => {
        goToQuickLink({
            status: [
                {
                    label: 'To Do',
                    value: 'TODO',
                },
                {
                    label: 'In Progress',
                    value: 'IN_PROGRESS',
                },
            ],
            assignee: {
                id: null,
                value: username,
                label: `${firstName} ${lastName}}`,
                assignee: {
                    id: null,
                    userName: username,

                    firstName: firstName,
                    lastName: lastName,
                    imageName: '',
                },
            },
        });
    };
    const quickLinksObj: QuickLink[] = [
        {
            name: 'All Activities',
            gotoFunc: goToProgramBoardView,
        },
        {
            name: '30d Lookahead',
            gotoFunc: goto30dLookAhead,
        },
        {
            name: 'My Priorities',
            gotoFunc: gotoMyPriorities,
        },
        {
            name: 'Activities updated by me',
            gotoFunc: goToProgramUpdatedByMe,
        },
        {
            name: 'My Tracked Activities',
            gotoFunc: gotoMyTrackedActivities,
        },
    ];

    return (
        <>
            <div className={classes.headline}>Quick Links</div>
            {quickLinksObj &&
                quickLinksObj.length > 0 &&
                quickLinksObj.map((item) => (
                    <QuickLinkCard
                        key={item.name}
                        title={item.name}
                        action={item.gotoFunc ? item.gotoFunc : () => {}}
                    />
                ))}
        </>
    );
};
